import { render, staticRenderFns } from "./heat-map.vue?vue&type=template&id=55060a5a"
import script from "./heat-map.vue?vue&type=script&lang=js"
export * from "./heat-map.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports